var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-layout-grid',[_c('empty-state-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }